import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import type * as React from 'react'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-full border px-2 py-0.5 sm:px-2.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 leading-tight text-center',
  {
    variants: {
      variant: {
        default:
          'border-primary/40 bg-primary/10 text-primary hover:bg-primary/20',
        secondary:
          'border-muted-foreground/30 bg-muted/50 text-muted-foreground hover:bg-muted/70',
        destructive:
          'border-red-300/50 bg-red-50/50 text-red-600 dark:border-red-500/30 dark:bg-red-950/30 dark:text-red-400 hover:bg-red-100/50 dark:hover:bg-red-950/50',
        outline: 'text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

interface BadgeProperties
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...properties }: BadgeProperties) {
  return (
    <div
      className={cn(badgeVariants({ variant }), className)}
      {...properties}
    />
  )
}

export { Badge }
